import Vue from 'vue'
import Vuetify from 'vuetify/lib'

// Hotfix for ripple not found when using v-simple-checkbox
import Ripple from 'vuetify/lib/directives/ripple'
Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

// TODO, dynamic imports
import en from 'vuetify/es5/locale/en'
import fr from 'vuetify/es5/locale/fr'
import es from 'vuetify/es5/locale/es'
import pt from 'vuetify/es5/locale/pt'
import pl from 'vuetify/es5/locale/pl'

const vuetify = new Vuetify({
  lang: {
    locales: { en, fr, es, pt, pl },
    current: 'en',
  },
})

import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
Vue.use(VueTelInputVuetify, {
  vuetify,
});

export default ({ translations }) => {
  // Use the translations for dynamic import of locales
  return vuetify
}